import { ChangeDetectorRef, Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { NotificationDialogComponent } from 'src/app/shared/navbar/notification/notification-dialog/notification-dialog.component';
import { PermissionService } from 'src/app/shared/permission.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import {
  COLUMNS_TO_SHOW_MOBILE,
  COLUMNS_TO_SHOW_WEB,
  TABLE_CONFIG_COLUMNS,
} from '../crud-config';
import { NotificationsService } from '../crud-service';

@Component({
  selector: 'app-notificaion-index',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.sass'],
  providers: [NotificationsService]
})
export class NotificationCrudIndex
  extends AbstractCrudIndex<any>
  implements ITableResponsive
{
  override title = 'Notificações';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;
  private refreshInterval: Subscription;


  currentTab: string = 'notifications'; 
  userType: string = 'admin'; 
  public filterFormValues: any = null
  constructor(
    public override dialog: MatDialog,
    public override service: NotificationsService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router,
    protected cdr: ChangeDetectorRef,
    protected authService: AuthService, 
    public permissionService: PermissionService,
    public dialogRef: MatDialogRef<NotificationCrudIndex>
    
  ) {
    super(dialog, service, toastService, mediaObserver, router);
  
    
    this.userType = this.authService.isPartner() ? 'partner' : 'admin';
    this.currentTab = 'notifications';
  
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }
  


  ngAfterViewInit(): void {
    this.loadList();
  }


  override loadList() {
    let params = this.params;
   
   this.service.getAllUserNotifications(params).subscribe({
      next: (data) => {
        this.dataSource = this.getDataSource(data);
      },
      error: (error) => {
        console.error('Erro ao carregar notificações:', error);
      },
    });
  }

  public getDataSource(data: any): MatTableDataSource<any> {
    return new MatTableDataSource<any>(
      data.map((item: any) => {
        item['type'] = item.type;
        item['name'] = item.user.firstName;
        item['message'] = item.message;
        item['seen'] = item.seen;
        item['createdAt'] = moment(item.createdAt).format('DD/MM/YYYY HH:mm');
        item['hideEdit'] = !item.allowEdit;
        item['hideDelete'] = !item.allowDelete;
        console.log(item);
        return item;
      })
    );  
  }

  public _openShow(element: any) {
    const dialogRefNotification = this.dialog.open(NotificationDialogComponent, {
      width: '400px',
      data: {
          ...element,
          userInfo: {
              name: element.createdBy?.name || element.userName || 'Sistema',
              userId: element.user?.id,
              customerId: element.customer?.id,
              partnerId: element.partner?.id
          }
      },
    });
    //Logica para fechar primeiro modal apos o fechamento do segundo
    // dialogRefNotification.afterClosed().subscribe(result => {
    //     this.dialogRef.close({ refreshCarousel: true, shouldCloseFirstModal: true }); 
    // });

    //Fecha primeiro modal ao abrir o segundo
    // this.dialogRef.close({ refreshCarousel: true, shouldCloseFirstModal: true });
  }


}
